import { masterTradeStatusLabel } from './master-trade-status'
import { TradeListRow } from './trade-list-rows'

export type ExportTradeDataParams = {
    status: string;
    tradeId: string;
    internalId: string;
    tradeDetails: string;
    transferType: string;
    tradeAction: string;
    tradeDate: string;
    myEntity: string;
    mei: string;
    counterparty: string;
    counterpartyMei: string;
    deal: string;
    dealCusip: string;
    facilities: string;
    tradedAmount: string;
    currentAmount: string;
    price: string;
    agent: string;
}

/**
 * The table's built-in export, the same data the page always exported: ONE
 * row per traded facility of each master trade (a trade with several
 * facilities gives several rows), the trade's columns repeated on each, the
 * facility's name, traded amount, last amount and price as the ledger's text.
 * A trade with no traded facility still gives one row, with a traded amount
 * of '0'. Trade ID is the trade's internal key, as it always was.
 */
export const transformTradeDataForExport = (rows: TradeListRow[]): ExportTradeDataParams[] =>
    rows.flatMap(trade => {
        const facilities = trade.tradedFacilities.length > 0
            ? trade.tradedFacilities
            : [{ name: '', tradeAmount: '0', currentAmount: '', price: '' }]
        return facilities.map(facility => ({
            status: masterTradeStatusLabel(trade.status),
            tradeId: trade.id || '',
            internalId: trade.clientId || '',
            tradeDetails: trade.tradeDetails || '',
            transferType: trade.transferType || '',
            tradeAction: trade.myEntity || '',
            tradeDate: trade.tradeDate || '',
            myEntity: trade.entityName || '',
            mei: trade.entityMei || '',
            counterparty: trade.counterpartyName || '',
            counterpartyMei: trade.counterpartyMei || '',
            deal: trade.dealName || '',
            dealCusip: trade.dealCusip || '',
            agent: trade.agent,
            facilities: facility.name || '',
            tradedAmount: facility.tradeAmount || '',
            currentAmount: facility.currentAmount || '',
            price: facility.price || '',
        }))
    })
